import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-result',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class ResultComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  openAlumniRegistrationForm() {
    window.open('https://forms.gle/q4JE9D7RqCgnUZrW8', '_blank')
  }

}
